

const type ={
    login:"[auth] login",
    logout:"[auth] logout",
    updateProfile:"[auth] updateProfile",

    setRequestError:"[request] error",
    removeRequestError:"[request] remove error",
    startLoading:"[request] start loading",
    stopLoading:"[request] stop loading",
    setSuccessRequest:"[request] success",
    removeSuccessRequest:"[request] remove success",

    updateDashboardDrawerVisibility:"[dashboard] update drawer visibility",
    updateStation:"[dashboard] update sensors",
    updateSelectedStation:"[dashboard] update selectedStation",
    updateAlias:"[dashboard] update alias",
    updateCompareStation:"[dashboard] update compareStations",
    updateAQI:"[dashboard] update AQI",

    //download list actions
    setDownloadListAction:"[download list] set downloadList",
    updateDownloadStateAction:"[download list] update downloadList state",
    deleteDownloadAction:"[download list] delete download ",
    createDownloadAction:"[download list] create download ",

    //download progress actions
    addDownloadProcessAction:"[download process] add download process",
    removeDownloadProcessAction:"[download process] remove download process",
    removeAllDownloadProcessAction:"[download process] remove all download process",
    updateDownloadProgressAction:"[download process] update download process progress",
    setDownloadProcessErrorAction:"[download process] set download process error",

    //visibility action
    setDownloadMinimizedAction:"[download visibility] set download minimized state",

    //download progress actions
    setProcessingProgressListAction:"[download progress] set processing progress list",
    removeProcessingProgressListAction:"[download progress] remove processing progress downloads",
    updateProcessingProgressListAction:"[download progress] update processing progress downloads",

    //report
    setReportListAction:"[report] set report list",
    updateReportStateAction:"[report] update report list",
    deleteReportAction:"[report] delete report from list",
    createReportAction:"[report] add report to list",

    //report progress actions
    setReportProcessingProgressListAction:"[report progress] set processing progress list",
    removeReportProcessingProgressListAction:"[report progress] remove processing progress report",
    updateReportProcessingProgressListAction:"[report progress] update processing progress report",

    //alarms
    addAlarmAction : "[alarms] add alarm",
    removeAlarmAction : "[alarms] remove alarm",
    setAlarmsAction : "[alarms] set alarms",

    //notifications
    addNotificationAction : "[notification] add notification",
    removeNotificationByIdAction : "[notification] remove notification by id",
    removeNotificationByAlarmIdAction : "[notification] remove notification by alarm id",
    setNotificationsAction : "[notification] set notifications",

}

export default type